import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const CronoVoiceVisualizerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .controls-container {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 8px 16px;
    height: 56px;

    border: 1px solid ${colors.grey444};
    border-radius: 8px;
    overflow: hidden;
    background: ${colors.white};

    &.start-recording-theme {
      background: ${colors.grey6};
      border: none;
      width: fit-content;
      &:hover {
        background: ${colors.grey444};
        cursor: pointer;
        .icon-container {
          background: ${colors.inactiveHover};
        }
      }
    }
    &.size-small {
      height: 48px;
    }
    .left-controls,
    .right-controls {
      display: flex;
      align-items: center;
    }
    .left-controls {
      gap: 11px;
    }
    .right-controls {
      gap: 8px;
    }

    .visualizer-container {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;

      //class that voice-visualizer library use
      .voice-visualizer {
        flex: 1;
      }

      .voice-waves-container {
        overflow-y: hidden;
        height: 40px !important;
        width: 100%;
        display: flex;
        align-items: center;

        canvas {
          width: 100% !important;
          height: 40px !important;
        }
      }
    }

    .recording-time {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      min-width: 125px;
    }

    .button {
      display: flex;
      align-items: center;
      height: 40px;
      padding: 10px;
      background: #010e27;
      border-radius: 24px;
      cursor: pointer;

      &-text {
        font-weight: 500;
        font-size: 14px;
        font-family: 'Poppins', sans-serif;
        color: white;
      }
    }

    .recorder-button {
      display: flex;
      gap: 8px;
      cursor: pointer;
      min-width: fit-content;
      align-items: center;

      .icon-container {
        background: ${colors.inactive};
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
      }
    }

    .dot-icon-container {
      padding: 0 9px;
      display: flex;
      align-items: center;
    }

    .circle-button {
      all: unset;
      width: 30px;
      height: 30px;
      min-width: 30px;
      min-height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      border-radius: 50%;

      svg {
        height: 18px;
      }
    }

    .play-pause-button {
      background: ${colors.primary};
    }

    .delete-button {
      background: ${colors.inactiveLight};
      &:hover {
        background: ${colors.inactiveLightHover};
      }
    }

    .save-button {
      background: ${colors.greenLight};
      &:hover {
        background: ${colors.greenLightHover};
      }
    }
  }
`;
